import { useQuery } from 'react-query';
import { CustomerPhotographerBookingApi } from './CustomerPhotographerBookingApi';
import { BookableDays } from '../bookingDateSelect/state/dateHelper';
import { bookableDaysOf } from '../bookingDateSelect/state/useBookableDaysFrom';
import { BookableDatesResult } from '../types';

type FirstBookableDateQueryArgs = {
    orderId?: number | null;
    productIds?: number[];
    brokerFirmId?: number | null;
    enabled?: boolean;
};

export type FirstBookableDate = BookableDays & {
    isFinished: boolean;
};

export let firstBookableDateQueryKey = 'photographer-booking-first-bookable-date';

export function useFirstBookableDateQuery({
    orderId = null,
    productIds = [],
    brokerFirmId = null,
    enabled = true
}: FirstBookableDateQueryArgs): FirstBookableDate {
    let sortedProductIds = productIds.slice().sort((a, b) => a - b);
    let shouldFetch = enabled && (orderId !== null || sortedProductIds.length > 0);

    let { data, isSuccess, isError } = useQuery<BookableDatesResult>(
        [firstBookableDateQueryKey, { orderId, productIds: sortedProductIds, brokerFirmId }],
        () =>
            CustomerPhotographerBookingApi.getFirstBookableDate(
                orderId,
                sortedProductIds,
                brokerFirmId
            ),
        {
            enabled: shouldFetch,
            // The answer changes at 17:00 and at midnight.
            staleTime: 60 * 1000,
            retry: 1
        }
    );

    return {
        ...bookableDaysOf(data),
        isFinished: !shouldFetch || isSuccess || isError
    };
}
